import React, { useState } from "react";
import { Radio, ConfigProvider } from "antd";
import "antd/dist/reset.css";
import "./single-select-filter.scss";

export default function SingleSelectFilter({
  filterKey,
  filterTags,
  filterDefinition,
  allowDeselect = false,
  onChange,
}) {
  const selectedValue = filterTags?.find((tag) => tag.key === filterKey)?.value ?? null;

  const handleChange = (e) => {
    const newValue = e.target.value;

    const option = filterDefinition.options.find(
      (o) => o.type === e.target.value
    );

    onChange?.(option);
  };

  const handleClick = (option) => {
    if (allowDeselect && option.type === selectedValue) {
      onChange?.(null);
    } else {
      onChange?.(option);
    }
  };

  return (
    <div className="single-select-tab">
      <div className="wrap-box">
        <h6>{filterDefinition.name}</h6>

        <ConfigProvider
          theme={{
            components: {
              Radio: {
                colorPrimary: "#CBA135",
                colorPrimaryHover: "#CBA135",
              },
            },
          }}
        >
          <Radio.Group
            value={selectedValue}
            onChange={handleChange}
            className="radio-group"
          >
            {filterDefinition.options.map((option, index) => {
              const selected = selectedValue === option.type;

              return (
                <div className="radio-container" key={option.type}>
                  <div className="radio-item">
                    <Radio
                      data-option={option}
                      value={option.type}
                      onClick={() => handleClick(option)}
                    >
                      <div className="radio-content">
                        <div className="radio-left">
                          <span
                            className={`radio-label ${
                              selected ? "selected" : ""
                            }`}
                          >
                            {option.name}
                          </span>

                          {/* <span className="radio-count">({option.count})</span> */}
                        </div>

                        <div className="radio-price">
                          {option.displayLowestPrice}
                        </div>
                      </div>
                    </Radio>
                  </div>
                </div>
              );
            })}
          </Radio.Group>
        </ConfigProvider>
      </div>
    </div>
  );
}
